export class DateDevIdClientCodeIsTotalReq{
    date: string;
    divisionId:number;
    clientCode:string;
    isTotal:number
}